// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2m0lS","selected":"styles_selected__3U6aU"};